import { render, staticRenderFns } from "./CorporateAnnouncementBondDetails.vue?vue&type=template&id=4b38e6d8&scoped=true"
import script from "./CorporateAnnouncementBondDetails.vue?vue&type=script&lang=js"
export * from "./CorporateAnnouncementBondDetails.vue?vue&type=script&lang=js"
import style0 from "./CorporateAnnouncementBondDetails.vue?vue&type=style&index=0&id=4b38e6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b38e6d8",
  null
  
)

export default component.exports